import Swiper, { Pagination, Navigation, Autoplay } from "swiper";

export default class ModSliderSolucoes {
    constructor() {

        this.module = document.querySelector('.modulo-slider_de_solucoes')
        this.slider = this.module.querySelector(".swiper--modulo-slider_de_solucoes");
		this.navigationPrev = this.module.querySelector(".slider-button-prev")
        this.navigationNext = this.module.querySelector(".slider-button-next")		

        this.ready()

    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            spaceBetween: 30,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            },
			slidesOffsetAfter: 42,
            breakpoints: {
                0: {
                    slidesPerView: 1.4,
					slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                },
                640: {
                    slidesPerView: 1.4,
					slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                },
                768: {
                    slidesPerView: 2.4,
					slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                },
                1024: {
                    slidesPerView: 2.3,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 42,
                },
            },
        })
        
    }

}